import DataService from "@/services/DataService";

export default {
  login(context, payload) {
    return new Promise((resolve, reject) => {
      if (!payload || !payload.creds) {
        DataService.getCurrentUser()
          .then(resp => {
            context.commit("loginSuccess", resp.data[0]);
            resolve(resp);
          })
          .catch(err => {
            reject(err);
            context.commit("logout");
          });
      } else {
        DataService.login(payload.creds.username, payload.creds.password)
          .then(resp => {
            localStorage.setItem("user-token", resp.data.token);
            DataService.getCurrentUser().then(resp => {
              context.commit("loginSuccess", resp.data[0]);
              resolve(resp);
            });
          })
          .catch(err => {
            reject(err);
            context.commit("logout");
          });
      }
    });
  },
  logout(context) {
    context.commit("logout");
  }
};
